import { render, staticRenderFns } from "./file2.vue?vue&type=template&id=9ae88a34"
import script from "./file2.vue?vue&type=script&lang=js"
export * from "./file2.vue?vue&type=script&lang=js"
import style0 from "./file2.vue?vue&type=style&index=0&id=9ae88a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports